import React, { useState, useEffect } from 'react';
import { adminAPI } from '../../../services/api';
import './Management.css';
//import { FiYoutube } from 'react-icons/fi';

const ConfigurationManagement = () => {
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [testStatus, setTestStatus] = useState({
    loading: false,
    message: null,
    isError: false,
  });

  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    address: '',
    schedule: '',
    whatsapp_number: '',
    map_embed_url: '',
    facebook_url: 'https://facebook.com',
    instagram_url: 'https://instagram.com',
    youtube_url: 'https://youtube.com',
    tiktok_url: '',
    carousel_effect: 'slide',
    carousel_speed: 1000,
    default_banner_duration: 5000,
    smtp_host: '',
    smtp_port: '',
    smtp_user: '',
    smtp_password: '',
    email_to: ''
  });

  useEffect(() => {
    loadConfiguration();
  }, []);

  const loadConfiguration = async () => {
    try {
      const response = await adminAPI.getConfiguration();
      if (response.data && Object.keys(response.data).length > 0) {
        setFormData(prev => ({ ...prev, ...response.data }));
      }
    } catch (error) {
      console.error('Error loading configuration:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await adminAPI.updateConfiguration(formData);
      alert('Configuración actualizada correctamente');
    } catch (error) {
      alert('Error al guardar la configuración');
      console.error(error);
    }
  };

  const handleTestEmail = async () => {
    setTestStatus({ loading: true, message: null, isError: false });
    try {
      const response = await adminAPI.testEmailConfig(formData);
      setTestStatus({
        loading: false,
        message: response.data.message,
        isError: false,
      });
    } catch (error) {
      setTestStatus({
        loading: false,
        message: error.response?.data?.message || 'Ocurrió un error inesperado al probar el envío.',
        isError: true,
      });
    }
  };

  const handleHeroImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    setUploadProgress(0);
    try {
      const response = await adminAPI.uploadFile(file, (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setUploadProgress(percentCompleted);
      });
      // Construimos la URL completa para guardarla y mostrar la vista previa
      const imageUrl = `/api/files/${response.data.file_path}`;
      setFormData(prev => ({ ...prev, hero_style_value: imageUrl }));
    } catch (error) {
      console.error('Error uploading file:', error);
      if (error.response && error.response.status === 413) {
        alert('Error 413: El archivo es demasiado grande para el servidor. Revisa el límite "client_max_body_size" en Nginx.');
      } else {
        alert('Error al subir el archivo');
      }
    } finally {
      setUploading(false);
    }
  };

  if (loading) return <div className="loading">Cargando...</div>;

  return (
    <div className="management">
      <div className="management-header">
        <h1>Configuración del Sitio</h1>
      </div>

      <form onSubmit={handleSubmit} className="form" style={{ maxWidth: '800px' }}>
        <div className="form-group">
          <label>Email de Contacto</label>
          <input
            type="email"
            value={formData.email || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))}
            placeholder="ej: ventas@imdi.com"
          />
        </div>
        <div className="form-group">
          <label>Teléfono</label>
          <input
            type="text"
            value={formData.phone || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, phone: e.target.value }))}
            placeholder="ej: +58 412-0000000"
          />
        </div>
        <div className="form-group">
          <label>WhatsApp (Botón Flotante)</label>
          <input
            type="text"
            value={formData.whatsapp_number || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, whatsapp_number: e.target.value }))}
            placeholder="ej: 584120000000"
          />
          <small>Ingresa el número en formato internacional sin el símbolo '+' (ej: 584121234567)</small>
        </div>
        <div className="form-group">
          <label>Dirección</label>
          <textarea
            value={formData.address || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, address: e.target.value }))}
            rows="3"
            placeholder="Dirección física de la tienda"
          />
        </div>
        <div className="form-group">
          <label>Horario de Atención</label>
          <input
            type="text"
            value={formData.schedule || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, schedule: e.target.value }))}
            placeholder="ej: Lunes a Viernes: 8:00 AM - 5:00 PM"
          />
        </div>
        <div className="form-group">
          <label>URL del Mapa (Embed Src)</label>
          <textarea
            value={formData.map_embed_url || ''}
            onChange={(e) => {
              let value = e.target.value;
              // Auto-extraer URL si el usuario pega el código iframe completo
              if (value.includes('<iframe')) {
                const match = value.match(/src="([^"]+)"/);
                if (match) value = match[1];
              }
              setFormData(prev => ({ ...prev, map_embed_url: value }));
            }}
            rows="4"
            placeholder="Pega aquí solo la URL que está dentro de src='...' del código de compartir de Google Maps"
          />
          <small>Ve a Google Maps - Compartir - Insertar un mapa - Copia el enlace dentro de las comillas de src="..."</small>
        </div>

        <h3 style={{ marginTop: '2rem', marginBottom: '1rem', color: '#333' }}>Redes Sociales</h3>

        <div className="form-group">
          <label>Facebook URL</label>
          <input
            type="url"
            value={formData.facebook_url || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, facebook_url: e.target.value }))}
            placeholder="https://facebook.com/..."
          />
        </div>
        <div className="form-group">
          <label>Instagram URL</label>
          <input
            type="url"
            value={formData.instagram_url || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, instagram_url: e.target.value }))}
            placeholder="https://instagram.com/..."
          />
        </div>
        <div className="form-group">
          <label>YouTube URL</label>
          <input
            type="url"
            value={formData.youtube_url || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, youtube_url: e.target.value }))}
            placeholder="https://youtube.com/..."
          />
        </div>
        <div className="form-group">
          <label>TikTok URL</label>
          <input
            type="url"
            value={formData.tiktok_url || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, tiktok_url: e.target.value }))}
            placeholder="https://tiktok.com/@..."
          />
        </div>

        <h3 style={{ marginTop: '2rem', marginBottom: '1rem', color: '#333' }}>Apariencia</h3>
        <div className="form-group">
          <label>Efecto del Carrusel</label>
          <select
            value={formData.carousel_effect || 'slide'}
            onChange={(e) => setFormData(prev => ({ ...prev, carousel_effect: e.target.value }))}
          >
            <option value="slide">Deslizar (Clásico)</option>
            <option value="fade">Desvanecer (Fade)</option>
            <option value="cube">Cubo 3D</option>
            <option value="coverflow">Coverflow 3D</option>
            <option value="flip">Voltear 3D</option>
          </select>
        </div>

        <div className="form-group">
          <label>Velocidad de Transición (ms) - "Retardo del efecto"</label>
          <input
            type="number"
            value={formData.carousel_speed || 1000}
            onChange={(e) => setFormData(prev => ({ ...prev, carousel_speed: parseInt(e.target.value) }))}
          />
          <small>Tiempo que tarda en cambiar de un banner a otro (ej: 1000ms = 1 segundo).</small>
        </div>

        <div className="form-group">
          <label>Duración por Defecto del Banner (ms)</label>
          <input
            type="number"
            value={formData.default_banner_duration || 5000}
            onChange={(e) => setFormData(prev => ({ ...prev, default_banner_duration: parseInt(e.target.value) }))}
          />
          <small>Tiempo que permanece visible cada banner (si no se especifica uno individual).</small>
        </div>

        <h3 style={{ marginTop: '2rem', marginBottom: '1rem', color: '#333' }}>Configuración de Envío de Correo (SMTP)</h3>
        <small style={{ display: 'block', marginBottom: '1.5rem', color: '#666' }}>
          Estos datos son necesarios para que el formulario de contacto pueda enviar correos.
        </small>

        <div className="form-group">
          <label>Host SMTP</label>
          <input
            type="text"
            value={formData.smtp_host || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, smtp_host: e.target.value }))}
            placeholder="ej: smtp.gmail.com"
          />
        </div>

        <div className="form-group">
          <label>Puerto SMTP</label>
          <input
            type="text"
            value={formData.smtp_port || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, smtp_port: e.target.value }))}
            placeholder="ej: 587 o 465"
          />
        </div>

        <div className="form-group">
          <label>Usuario SMTP (Email)</label>
          <input
            type="email"
            value={formData.smtp_user || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, smtp_user: e.target.value }))}
            placeholder="tu_correo@ejemplo.com"
          />
        </div>

        <div className="form-group">
          <label>Contraseña SMTP</label>
          <input
            type="password"
            value={formData.smtp_password || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, smtp_password: e.target.value }))}
            placeholder="Contraseña de aplicación o del correo"
          />
          <small>Se recomienda usar una contraseña de aplicación generada por tu proveedor de correo.</small>
        </div>

        <div className="form-group">
          <label>Email de Destino (donde se reciben los mensajes)</label>
          <input
            type="email"
            value={formData.email_to || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, email_to: e.target.value }))}
            placeholder="Correo donde se recibirán los mensajes del formulario"
          />
        </div>

        <div className="form-group">
          <button type="button" className="btn-secondary" onClick={handleTestEmail} disabled={testStatus.loading}>
            {testStatus.loading ? 'Probando...' : 'Probar Configuración de Correo'}
          </button>
          {testStatus.message && (
            <div className={`alert ${testStatus.isError ? 'error' : 'success'}`} style={{ marginTop: '1rem' }}>
              {testStatus.message}
            </div>
          )}
        </div>

        <div className="form-actions" style={{ justifyContent: 'flex-start' }}>
          <button type="submit" className="btn-primary">
            Guardar Cambios
          </button>
        </div>
      </form>
    </div>
  );
};

export default ConfigurationManagement;
